import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, langs } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.code === lang) || langs[0];

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 rounded-xl border border-blue-500/15 bg-white/60 hover:bg-blue-50 hover:border-blue-500/30 transition-colors ${
          compact ? 'h-9 px-2' : 'h-10 px-3'
        }`}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="text-lg leading-none">{current.flag}</span>
        <span className="hidden sm:inline text-xs uppercase tracking-widest font-medium text-slate-700">{current.code}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-slate-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 rounded-xl border border-blue-500/15 bg-white shadow-lg overflow-hidden z-50" role="listbox">
          {langs.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`flex items-center justify-between w-full px-3 py-2.5 text-sm text-left transition-colors ${
                l.code === lang ? 'bg-blue-50 text-blue-700' : 'text-slate-700 hover:bg-slate-50'
              }`}
              role="option"
              aria-selected={l.code === lang}
            >
              <span className="flex items-center gap-2">
                <span className="text-base leading-none">{l.flag}</span>
                <span>{l.label}</span>
              </span>
              {l.code === lang && <Check className="h-4 w-4 text-blue-600" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
